import React from "react";

const TwitterIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><path d="M12.585 0h2.466l-5.375 5.93 6.324 8.07h-4.933l-3.858-4.89-4.427 4.89h-2.466l5.755-6.358-6.071-7.642h5.059l3.478 4.463zm-.885 12.594h1.391l-8.791-11.249h-1.455z" fill={props.fill} /></svg>
    )
}

export default TwitterIcon;
